import { WebPaymentTypeEnum } from '@up/data';

export class PaymentActionRequestV2Dto {
  paymentId: number;
  amount?: number;
  comment?: string;
  webPaymentType?: WebPaymentTypeEnum;
}
